/* eslint-disable react-hooks/exhaustive-deps */
import { Dialog, DialogContent } from "@mui/material";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import {
    SvgAddSelfie,
    SvgCheckMark,
    SvgCrossMark,
    SvgLogo,
    SvgNotAvailableMark,
    SvgPendingMark,
    SvgRightArrow,
} from "assets/svg";
import axios from "axios";
import cn from "classnames";
import { useAuthContext } from "context/AuthContext";
import instance from "instances/axios";
import moment from "moment";
import { useEffect, useState } from "react";
import "react-clock/dist/Clock.css";
import { Link, useNavigate } from "react-router-dom";
import s from "./Dashboard.module.css";

const PrettoSlider = styled(Slider)({
    padding: "0px 0px 56px 0px !important",
    color: "#52af77",
    height: 8,
    "& .MuiSlider-track": {
        border: "none",
    },
    "& .MuiSlider-thumb": {
        height: 16,
        width: 16,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: "inherit",
        },
        "&:before": {
            display: "none",
        },
    },
    "& .MuiSlider-valueLabel": {
        lineHeight: 1.2,
        fontSize: 12,
        background: "unset",
        color: "#002CB7",
        padding: 0,
        width: 24,
        height: 24,
        borderRadius: "50% 50% 50% 0",
        backgroundColor: "transparent",
        transformOrigin: "bottom left",
        transform: "translate(50%, 130%) rotate(-45deg) scale(0)",
        "&:before": { display: "none" },
        "&.MuiSlider-valueLabelOpen": {
            transform: "translate(50%, 130%) rotate(-45deg) scale(1)",
        },
        "& > *": {
            transform: "rotate(45deg)",
        },
    },
});

function Dashboard() {
    // const [value, setValue] = useState(new Date());
    const [fullName, setFullName] = useState("");
    // const [isChallengeStarted, setIsChallengeStarted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { user, dispatch, users, setUsers } = useAuthContext();
    const [isGetUpTimePassed, setIsGetUpTimePassed] = useState(false);
    const [isAlreadyGetUp, setIsAlreadyGetUp] = useState(false);
    const [passedDays, setPassedDays] = useState(1);
    const [open, setOpen] = useState(false);
    //   const [_challengeData, setIsChallengeData] = useState();
    const [isSelfie, setIsSelfie] = useState(false);
    const [feeling, setFeeling] = useState("");
    const [hard, setHard] = useState("");
    const [reward, setreward] = useState("");
    const [rewards, setRewards] = useState();
    const navigate = useNavigate();
    const [dateData, setDateData] = useState();
    const [daysper, setDaysPer] = useState();
    // eslint-disable-next-line no-unused-vars
    const [_allRewards, setAllRewards] = useState([]);

    const getUpTimes = [
        {
            day1: "null",
            day2: "null",
            day3: "null",
            day4: "null",
            day5: "null",
            day6: "null",
            day7: "null",
            day8: "null",
            day9: "null",
            day10: "null",
            day11: "null",
            day12: "null",
            day13: "null",
            day14: "null",
            day15: "null",
            day16: "null",
            day17: "null",
            day18: "null",
            day19: "null",
            day20: "null",
            day21: "null",
            day22: "null",
            day23: "null",
            day24: "null",
            day25: "null",
            day26: "null",
            day27: "null",
            day28: "null",
            day29: "null",
            day30: "null",
        },
    ];

    const getReward = async () => {
        try {
            const data = await instance.get(`/reward/${user.userindex}`);
            const total = data?.data?.data;
            const totalRewardAmount = total.reduce((sum, reward) => sum + parseFloat(reward.reward_amount), 0);
            setRewards(total);
            setreward(totalRewardAmount);
        } catch (error) {
            console.log(error);
        }
    };

    //   const updateGetUpTime = async () => {
    //     try {
    //       const date = new Date();
    //       await instance
    //         .put("/getuptime/update", {
    //           userid: user.userid,
    //           get_up_time: [
    //             { Day: dateData.length + 1, Time: `${date}`, Checked: true },
    //           ],
    //         })
    //         .then((data) => console.log(data));
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   };

    const createReward = async () => {
        try {
            const currentDate = new Date();
            if (currentDate?.getHours() <= 6 && currentDate?.getHours() >= 5) {
                const payload = {
                    userid: user.userid,
                    reward_amount: 0.02,
                    reward_date: currentDate,
                };
                await instance.post(`/reward/create`, payload);
                // updateGetUpTime();
            } else {
                alert("Reward creation is allowed only before 6 AM.");
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getAllReward = async () => {
        try {
            const data = await instance.get(`/reward/all`);
            setAllRewards(data?.data?.data);
        } catch (error) {
            console.log(error);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const caldays = () => {
        let count = 0;
        console.log("COUNT :", count);
        dateData &&
            dateData.map((val) => {
                if (val.Checked !== null && val.Checked !== false) {
                    count++;
                }
                return null; // Map function expects a return value, even if it's null in this case.
            });

        const calculateddata = Math.round((count * 100) / 30);
        setDaysPer(calculateddata);
    };

    // eslint-disable-next-line no-unused-vars

    useEffect(() => {
        if (!user) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        (async () => {
            const data = await instance.get("/users/").then((r) => r.data.data);
            setUsers(data);
            if (data) {
                getReward();
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const init = () => {
            const off_set = user.off_set;
            const challengeStartDate = process.env.REACT_APP_START_CHALLENGE_DATE;
            const [challengeStartYear, challengeStartMonth, challengeStartDay] = challengeStartDate.split("/");
            const now = new Date();
            const utc = now.getTime() + now.getTimezoneOffset() * 60000; // Get current UTC time
            const targetTime = new Date(utc + 3600000 * off_set); // Calculate time in the target time zone
            const month = (targetTime.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
            const day = targetTime.getDate().toString().padStart(2, "0");
            const hours = targetTime.getHours().toString().padStart(2, "0"); // Get hours in 24-hour format and pad with 0 if needed

            let passedDays = 0;
            const daysOfMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            if (
                (parseInt(challengeStartYear) % 4 === 0 && parseInt(challengeStartYear) % 100 !== 0) ||
                parseInt(challengeStartYear) % 400 === 0
            ) {
                daysOfMonth[2] = 29;
            }
            if (month > challengeStartMonth) {
                passedDays = parseInt(day) + daysOfMonth[challengeStartMonth] - challengeStartDay + 1;
            } else {
                passedDays = parseInt(day) - parseInt(challengeStartDay) + 1;
            }
            setPassedDays(passedDays);
            // if (user?.getUpTimes[0][`day${passedDays}`] !== "null") {
            //     setIsAlreadyGetUp(true);
            // }
            // setValue(targetTime);
            if (parseInt(hours) > 5) {
                // setIsGetUpTimePassed(!true);
            }
        };
        if (user?.iskickoff === false) {
            navigate("/app_download");
        }
        init();
        const interval = setInterval(() => {
            init();
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [navigate, user?.getUpTimes, user?.iskickoff, user?.off_set]);

    useEffect(() => {
        (async () => {
            const data = await instance.get("/users/").then((r) => r.data.data);
            if (!!data) {
                data.forEach((userData) => {
                    if (userData.email === user.email) {
                        setFullName(userData.name);
                    }
                });
            } else {
                console.log("Data not found");
            }
        })();
    }, [user.email]);

    // useEffect(() => {
    // 	const challengeStartDate = process.env.REACT_APP_START_CHALLENGE_DATE;
    // 	const off_set = user.off_set;
    // 	const now = new Date();
    // 	const utc = now.getTime() + now.getTimezoneOffset() * 60000; // Get current UTC time
    // 	const targetTime = new Date(utc + 3600000 * off_set); // Calculate time in the target time zone
    // 	if (new Date(challengeStartDate) > targetTime) {
    // 		setIsChallengeStarted(false);
    // 	} else {
    // 		setIsChallengeStarted(true);
    // 	}
    // }, [user.off_set]);

    function valueLabelFormat(value) {
        return `${value}%`;
    }

    useEffect(() => {
        async function data() {
            await instance.get(`/getuptime/${user.userindex}`).then((res) => {
                const dates = res.data.data.get_up_time;
                setDateData(dates);
            });
        }
        if (!user) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
            data();
            caldays();
            getAllReward();
        }
    }, []);

    useEffect(() => {
        (async () => {
            const data = await instance.get("/users/").then((r) => r.data.data);
            setUsers(data);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const init = () => {
            const off_set = user.off_set;
            const challengeStartDate = process.env.REACT_APP_START_CHALLENGE_DATE;
            const [challengeStartYear, challengeStartMonth, challengeStartDay] = challengeStartDate.split("/");
            const now = new Date();
            const utc = now.getTime() + now.getTimezoneOffset() * 60000; // Get current UTC time
            const targetTime = new Date(utc + 3600000 * off_set); // Calculate time in the target time zone
            const month = (targetTime.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
            const day = targetTime.getDate().toString().padStart(2, "0");
            const hours = targetTime.getHours().toString().padStart(2, "0"); // Get hours in 24-hour format and pad with 0 if needed

            let passedDays = 0;
            const daysOfMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            if (
                (parseInt(challengeStartYear) % 4 === 0 && parseInt(challengeStartYear) % 100 !== 0) ||
                parseInt(challengeStartYear) % 400 === 0
            ) {
                daysOfMonth[2] = 29;
            }
            if (month > challengeStartMonth) {
                passedDays = parseInt(day) + daysOfMonth[challengeStartMonth] - challengeStartDay + 1;
            } else {
                passedDays = parseInt(day) - parseInt(challengeStartDay) + 1;
            }
            setPassedDays(passedDays);
            // if (user?.getUpTimes[0][`day${passedDays}`] !== "null") {
            //     setIsAlreadyGetUp(true);
            // }
            // setValue(targetTime);
            if (parseInt(hours) > 5) {
                setIsGetUpTimePassed(true);
            }
        };
        if (user?.iskickoff === false) {
            navigate("/app_download");
        }
        init();
        const interval = setInterval(() => {
            init();
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [navigate, user?.getUpTimes, user?.iskickoff, user?.off_set]);

    useEffect(() => {
        (async () => {
            const data = await instance.get("/users/").then((r) => r.data.data);
            if (!!data) {
                data.forEach((userData) => {
                    if (userData.email === user.email) {
                        setFullName(userData.name);
                    }
                });
            } else {
                console.log("Data not found");
            }
        })();
    }, [user.email]);

    // useEffect(() => {
    // 	const challengeStartDate = process.env.REACT_APP_START_CHALLENGE_DATE;
    // 	const off_set = user.off_set;
    // 	const now = new Date();
    // 	const utc = now.getTime() + now.getTimezoneOffset() * 60000; // Get current UTC time
    // 	const targetTime = new Date(utc + 3600000 * off_set); // Calculate time in the target time zone
    // 	if (new Date(challengeStartDate) > targetTime) {
    // 		setIsChallengeStarted(false);
    // 	} else {
    // 		setIsChallengeStarted(true);
    // 	}
    // }, [user.off_set]);

    const onGetUp = async () => {
        const off_set = user.off_set; // Offset for GMT-6:00 Chihuahua, La Paz, Mazatlan
        const now = new Date();
        const utc = now.getTime() + now.getTimezoneOffset() * 60000; // Get current UTC time
        const targetTime = new Date(utc + 3600000 * off_set); // Calculate time in the target time zone
        const year = targetTime.getFullYear();
        const month = (targetTime.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based, so add 1
        const day = targetTime.getDate().toString().padStart(2, "0");
        const hours = targetTime.getHours().toString().padStart(2, "0"); // Get hours in 24-hour format and pad with 0 if needed
        const minutes = targetTime.getMinutes().toString().padStart(2, "0"); // Get minutes and pad with 0 if needed
        const seconds = targetTime.getSeconds().toString().padStart(2, "0"); // Get minutes and pad with 0 if needed

        const currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

        const updates = {};
        user.getuptimes[0][`day${passedDays}`] = currentTime;
        updates["users/" + user.userindex] = {
            ...user,
            // getUpTimes: user?.getUpTimes,
            getUpTimes: getUpTimes,
        };
        setIsLoading(true);
        await axios("users/" + user.userindex, updates["users/" + user.userindex])
            .then(() => {
                setIsAlreadyGetUp(true);
                dispatch({ type: "AUTH_IS_READY", payload: user });
            })
            .catch((error) => {
                console.log(error);
            });
        setIsLoading(false);
    };

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            setIsSelfie(false);
        }, 500);
    };
    console.log(isAlreadyGetUp);
    const time = moment(parseInt(user?.createdAt || user?.createdat, 10)).fromNow();

    // const result = aggregateRewards(allRewards);

    return (
        <div className={s.root}>
            {/* User Profile */}
            <div
                className="w-full md:w-[600px] flex flex-col items-center justify-center gap-[18px] rounded-[20px] bg-[#EDEEEF]"
                style={{ boxShadow: "0px 5px 8px 0px rgba(0, 0, 0, 0.15)" }}
            >
                <div className="flex items-center justify-between gap-[12px] w-full">
                    <div className="flex items-center justify-center gap-[32px] w-1/2 p-[12px] text-[16px] font-bold">
                        <img src={user.photourl} alt="avatar" className="rounded-full w-[60px] h-[60px]" />
                        {fullName}
                    </div>
                    <div
                        className="flex items-center justify-center gap-[10px] text-[20px] text-white font-semibold w-1/2 h-[85px]"
                        style={{
                            background: "linear-gradient(270deg, #003CF6 0%, #002AB0 100%)",
                            boxShadow: "0px 5px 8px rgba(0, 0, 0, 0.15)",
                            borderBottomLeftRadius: 20,
                            borderTopRightRadius: 20,
                        }}
                    >
                        <SvgCheckMark />
                        {time.toUpperCase()}
                    </div>
                </div>
                <div className="text-[14px] font-semibold text-[#2250C7] w-full text-left px-[20px]">
                    The challenge is made on
                </div>
                <div className="w-full text-left px-[20px]">
                    <PrettoSlider
                        valueLabelDisplay="on"
                        aria-label="pretto slider"
                        value={daysper ? daysper : "0"}
                        valueLabelFormat={valueLabelFormat}
                    />
                </div>
            </div>

            {/* Token Info */}
            <div className="w-full md:w-[600px] flex items-center justify-center gap-[12px] mt-[16px]">
                <div
                    className="w-1/2 flex gap-[6px] items-center justify-center rounded-[15px] p-[12px]"
                    style={{
                        background: "#EDEEEF",
                        boxShadow: "0px 5px 8px 0px rgba(0, 0, 0, 0.15)",
                    }}
                >
                    <div className={s.title}>Number of tokens</div>
                    <div className={s.value}>{rewards?.length || "0"}</div>
                </div>
                <div
                    className="w-1/2 flex gap-[6px] items-center justify-center rounded-[15px] p-[12px]"
                    style={{
                        background: "linear-gradient(270deg, #003CF6 0%, #002AB0 100%)",
                        boxShadow: "0px 5px 8px rgba(0, 0, 0, 0.15)",
                    }}
                >
                    <div className="w-full text-[12px] font-[800] text-center text-white">Estimated reward</div>
                    <div className="w-full text-[20px] font-[800] text-center text-white">{reward ? reward : "0"}$</div>
                </div>
            </div>

            {/* Go To Chanllenge Chat */}
            <div
                className="w-full md:w-[600px] flex flex-col items-center justify-center gap-[16px] rounded-[20px] mt-[42px] bg-[#C9C9C9] p-[14px]"
                style={{ boxShadow: "0px 5px 8px 0px rgba(0, 0, 0, 0.15)" }}
            >
                {user?.group?.group_name === "C" && (
                    <Link
                        className="flex w-full h-[90px] rounded-[10px] items-center justify-start cursor-pointer"
                        style={{
                            background: "linear-gradient(270deg, #003CF6 0%, #002AB0 100%)",
                            border: "1px solid #003CF6",
                            boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.10)",
                        }}
                        to="https://t.me/Paliushyk"
                        target="_blank"
                    >
                        <div className="w-[45%] flex items-center justify-center">
                            <img src="assets/podcast.png" alt="podcast" />
                        </div>

                        {/* Token Info */}
                        <div className="w-full md:w-[600px] flex items-center justify-center gap-[12px] mt-[16px]">
                            <div
                                className="w-1/2 flex gap-[6px] items-center justify-center rounded-[15px] p-[12px]"
                                style={{
                                    background: "#EDEEEF",
                                    boxShadow: "0px 5px 8px 0px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                <div className={s.title}>Number of tokens</div>
                                <div className={s.value}>{rewards?.length || "0"}</div>
                            </div>
                            <div
                                className="w-1/2 flex gap-[6px] items-center justify-center rounded-[15px] p-[12px]"
                                style={{
                                    background: "linear-gradient(270deg, #003CF6 0%, #002AB0 100%)",
                                    boxShadow: "0px 5px 8px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                <div className="w-full text-[12px] font-[800] text-center text-white">
                                    Estimated reward
                                </div>
                                <div className="w-full text-[20px] font-[800] text-center text-white">
                                    {reward ? reward : "0"}$
                                </div>
                            </div>
                        </div>
                        <div className="w-[55%] text-white text-[15px] font-semibold">
                            Ask for motivation
                            <br /> from other
                            <br /> participants
                        </div>
                    </Link>
                )}
                <Link
                    className="flex w-full h-[64px] rounded-[10px] bg-[#003CF6] items-center overflow-hidden"
                    style={{
                        border: "1px solid #003CF6",
                    }}
                    to={user?.group?.group_link}
                    target="_blank"
                >
                    <div className="w-[75%] h-[120px] rounded-r-full bg-[#F6F4F4] flex items-center">
                        <div className={cn(s.goChatText)}>Go to the challenge chat</div>
                    </div>
                    <div className="w-[25%] h-[64px] bg-[#003CF6] flex items-center justify-center">
                        <SvgRightArrow />
                    </div>
                </Link>
            </div>

            {/* My Daliy Task Text */}
            <div
                className={cn(
                    s.gradientText,
                    "text-[20px] font-bold pl-[12px] mt-[40px] w-full md:w-[600px] self-center"
                )}
            >
                Your daily task
            </div>

            {/* Get Up Part */}
            <div className={isAlreadyGetUp ? s.getUpSuccess : isGetUpTimePassed ? s.getUpMissed : s.getUpAvailable}>
                <div className="flex items-center justify-between gap-[18px] w-full">
                    <div className="w-[30%]">
                        <img src={user.photourl} alt="avatar" className="rounded-full w-full" />
                    </div>
                    <div className="w-[70%]">
                        <div className="text-[#3E3E3E] text-[20px] font-bold">{time.toUpperCase()}</div>
                        <div className="text-[#3E3E3E] text-[16px] font-medium">
                            {isAlreadyGetUp
                                ? `Great, you did it!\nKeep it up`
                                : isGetUpTimePassed
                                ? `It's not a big deal.\nThe main thing is not to give up!`
                                : "Press the button\nI get up"}
                        </div>
                    </div>
                </div>

                <div
                    className={
                        isAlreadyGetUp
                            ? s.getUpSuccessButton
                            : isGetUpTimePassed
                            ? s.getUpMissedButton
                            : s.getUpAvailableButton
                    }
                >
                    <div
                        className="w-full text-[14px] font-bold text-center text-white py-[10px] cursor-pointer"
                        onClick={() => {
                            !isAlreadyGetUp && !isGetUpTimePassed && setOpen(true);
                            createReward();
                        }}
                    >
                        {isAlreadyGetUp ? `Task completed` : isGetUpTimePassed ? `You missed get up time` : "I get up"}
                    </div>
                </div>
            </div>

            <Dialog open={open} onClose={handleClose}>
                <DialogContent style={{ padding: "18px 12px 52px 12px" }}>
                    {isSelfie ? (
                        <div
                            className="px-[12px] pt-[33px] pb-[22px] rounded-[10px] bg-[#F6F4F4] flex flex-col items-center justify-center gap-[18px]"
                            style={{ border: "1px solid #003CF6" }}
                        >
                            <div className="flex items-center justify-between gap-[18px] w-full">
                                <div className="w-[30%]">
                                    <SvgAddSelfie />
                                </div>
                                <div className="w-[70%]">
                                    <div className="text-[#3E3E3E] text-[12px] sm:text-[14px] font-medium">
                                        You will get extra points if you send us a photo of how you got up in the
                                        morning. Click on the button, go to the chat and send your photo.
                                    </div>
                                </div>
                            </div>

                            <div
                                className="w-full flex items-center justify-center rounded-b-[10px] mt-[14px]"
                                style={{
                                    background: "linear-gradient(270deg, #003CF6 0%, #002AB0 100%)",
                                }}
                            >
                                <Link
                                    to={user?.group?.group_link}
                                    target="_blank"
                                    className="w-full text-[14px] font-bold text-center text-white py-[15px] cursor-pointer"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleClose();
                                        onGetUp();
                                    }}
                                >
                                    Take a selfie
                                </Link>
                            </div>
                        </div>
                    ) : (
                        <div
                            className="px-[12px] pt-[33px] pb-[22px] rounded-[10px] bg-[#F6F4F4] flex flex-col items-center justify-center gap-[18px]"
                            style={{ border: "1px solid #003CF6" }}
                        >
                            <SvgLogo className="w-[100px] h-[26px]" />
                            <div className="pt-[20px] text-[#393939] text-[20px] font-semibold">
                                How are you feeling?
                            </div>
                            <div className="w-full flex items-center justify-center gap-[6px]">
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        feeling === "bad" ? "opacity-100 bg-[#d11f1f]" : "opacity-70 bg-[#E72F2F]"
                                    }`}
                                    onClick={() => setFeeling("bad")}
                                >
                                    Bad
                                </div>
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        feeling === "normal" ? "opacity-100 bg-[#c3aa25]" : "opacity-70 bg-[#E7CA2F]"
                                    }`}
                                    onClick={() => setFeeling("normal")}
                                >
                                    Normal
                                </div>
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        feeling === "good" ? "opacity-100 bg-[#2073bf]" : "opacity-70 bg-[#2F8FE7]"
                                    }`}
                                    onClick={() => setFeeling("good")}
                                >
                                    Good
                                </div>
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        feeling === "excellent" ? "opacity-100 bg-[#178141]" : "opacity-70 bg-[#27B961]"
                                    }`}
                                    onClick={() => setFeeling("excellent")}
                                >
                                    Excellent
                                </div>
                            </div>
                            <hr />
                            <div className="text-[#393939] text-[16px] sm:text-[20px] font-semibold">
                                How hard was it to get up?
                            </div>
                            <div className="w-full flex items-center justify-center gap-[6px]">
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        hard === "bad" ? "opacity-100 bg-[#d11f1f]" : "opacity-70 bg-[#E72F2F]"
                                    }`}
                                    onClick={() => setHard("bad")}
                                >
                                    Bad
                                </div>
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        hard === "normal" ? "opacity-100 bg-[#c3aa25]" : "opacity-70 bg-[#E7CA2F]"
                                    }`}
                                    onClick={() => setHard("normal")}
                                >
                                    Normal
                                </div>
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        hard === "good" ? "opacity-100 bg-[#2073bf]" : "opacity-70 bg-[#2F8FE7]"
                                    }`}
                                    onClick={() => setHard("good")}
                                >
                                    Good
                                </div>
                                <div
                                    className={`w-[25%] py-[20px] text-[12px] font-semibold text-white rounded-[15px] text-center cursor-pointer hover:opacity-100 ${
                                        hard === "excellent" ? "opacity-100 bg-[#178141]" : "opacity-70 bg-[#27B961]"
                                    }`}
                                    onClick={() => setHard("excellent")}
                                >
                                    Excellent
                                </div>
                            </div>
                            <div
                                className="w-full flex items-center justify-center rounded-[5px] mt-[14px]"
                                style={{
                                    background: "linear-gradient(270deg, #003CF6 0%, #002AB0 100%)",
                                }}
                            >
                                <div
                                    className="w-full text-[14px] font-bold text-center text-white py-[15px] cursor-pointer"
                                    onClick={() => setIsSelfie(true)}
                                >
                                    Next
                                </div>
                            </div>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
            {/* Current Time */}
            {/* <div className="flex gap-8 text-[16px] font-bold">
				<p className=" text-[32px] font-bold my-4 text-black">
					{value.getHours() < 10
						? `0${value.getHours()}`
						: value.getHours() > 12
						? value.getHours() - 12
						: value.getHours()}
					:
					{value.getMinutes() < 10
						? `0${value.getMinutes()}`
						: value.getMinutes()}
					:
					{value.getSeconds() < 10
						? `0${value.getSeconds()}`
						: value.getSeconds()}
					{value.getHours() >= 12 ? '  PM' : '  AM'}
				</p>
			</div> */}

            {/* List of Participants Text */}
            <div
                className={cn(
                    s.gradientText,
                    "text-[20px] font-bold pl-[12px] mt-[40px] w-full md:w-[600px] self-center"
                )}
            >
                List of participants
            </div>

            {/* List of Participants */}
            <div className="w-full md:w-[600px] flex flex-col gap-[8px] mt-[16px]">
                <div className="flex items-center justify-center">
                    <div className="w-[15%]"></div>
                    <div className="w-[35%]"></div>
                    <div className="w-[25%] text-[10px] font-bold text-center">Number of tokens</div>
                    <div className="w-[25%] text-[10px] font-bold text-center">Estimated reward</div>
                </div>
                <hr />
                {users.slice(0, 3).map((item, idx) => (
                    <>
                        <div
                            key={idx}
                            className="flex items-center justify-center rounded-[15px] py-[4px] px-[6px]"
                            style={{ background: "rgba(3, 55, 222, 0.15)" }}
                        >
                            <div className="w-[15%]">
                                <img src={item.photourl} alt="avatar" className="rounded-full w-full" />
                            </div>
                            <div className={cn(s.gradientText, "w-[35%] text-center text-[14px] font-semibold")}>
                                {item?.name}
                            </div>
                            <div className="w-[25%] text-[12px] font-normal text-center">0</div>
                            <div className={cn(s.gradientText, "w-[25%] text-center text-[18px] font-semibold")}>
                                10$
                            </div>
                        </div>
                        <hr />
                    </>
                ))}

                {/* <div className="flex items-center justify-center rounded-[15px] py-[4px] px-[6px]">
                    <div className="w-[15%]">
                        <img src="/assets/avatar.png" alt="avatar" className="rounded-full" />
                    </div>
                    <div className={cn(s.gradientText, "w-[35%] text-center text-[14px] font-semibold")}>Username</div>
                    <div className="w-[25%] text-[12px] font-normal text-center">504</div>
                    <div className={cn(s.gradientText, "w-[25%] text-center text-[18px] font-semibold")}>10$</div>
                </div>
                <hr />
                <div className="flex items-center justify-center rounded-[15px] py-[4px] px-[6px]">
                    <div className="w-[15%]">
                        <img src="/assets/avatar.png" alt="avatar" className="rounded-full" />
                    </div>
                    <div className={cn(s.gradientText, "w-[35%] text-center text-[14px] font-semibold")}>Username</div>
                    <div className="w-[25%] text-[12px] font-normal text-center">504</div>
                    <div className={cn(s.gradientText, "w-[25%] text-center text-[18px] font-semibold")}>10$</div>
                </div>
                <hr />
                <div className="flex items-center justify-center rounded-[15px] py-[4px] px-[6px]">
                    <div className="w-[15%]">
                        <img src="/assets/avatar.png" alt="avatar" className="rounded-full" />
                    </div>
                    <div className={cn(s.gradientText, "w-[35%] text-center text-[14px] font-semibold")}>Username</div>
                    <div className="w-[25%] text-[12px] font-normal text-center">504</div>
                    <div className={cn(s.gradientText, "w-[25%] text-center text-[18px] font-semibold")}>10$</div>
                </div>
                <hr /> */}
                {user.length > 3 && (
                    <div
                        className="flex items-center justify-end mr-[20px] text-[12px] font-normal cursor-pointer"
                        style={{ color: "rgba(0, 60, 246, 0.54)" }}
                    >
                        view more participants
                    </div>
                )}
            </div>

            {/* Challenge calendar Text */}
            <div
                className={cn(
                    s.gradientText,
                    "text-[20px] font-bold pl-[12px] mt-[40px] w-full md:w-[600px] self-center mb-[24px]"
                )}
            >
                Challenge calendar
            </div>

            {/* Challenge calendar */}
            <div className="w-full md:w-[600px] flex gap-[2px] flex-wrap">
                {/* {dateData.map((challenge) =>
          !challenge.Checked ? (
            // parseInt(challenge.Day) <
            // (isGetUpTimePassed ? passedDays + 1 : passedDays)
            !challenge.Checked ? (
              <div className={s.calendarFailed} key={challenge.day}>
                <SvgCrossMark />
                Day{challenge.Day}
              </div>
            ) : // parseInt(challenge.day) ===
            //   (isGetUpTimePassed ? -1 : passedDays)
            challenge.Checked !== true || false ? (
              <div className={s.calendarPending} key={challenge.day}>
                <SvgPendingMark />
                Day{challenge.Day}
              </div>
            ) : (
              <div className={s.calendarNotAvailable} key={challenge.day}>
                <SvgNotAvailableMark />
                Day{challenge.Day}
              </div>
            )
          ) : (
            <div className={s.calendarSuccess} key={challenge.day}>
              <SvgCheckMark />
              Day{challenge.Day}
            </div>
          )
        )} */}
                {dateData &&
                    dateData?.map((challenge) =>
                        (dateData && !challenge?.Checked) || challenge?.Checked === null ? (
                            //   parseInt(challenge.Day) <
                            //   (isGetUpTimePassed ? passedDays + 1 : passedDays)
                            challenge?.Checked === false ? (
                                <div className={s.calendarFailed} key={challenge.Day}>
                                    <SvgCrossMark />
                                    Day{challenge.Day}
                                </div>
                            ) : //   parseInt(challenge.Day) ===
                            //     (isGetUpTimePassed ? -1 : passedDays)
                            challenge?.Checked === null ? (
                                <div className={s.calendarPending} key={challenge.Day}>
                                    <SvgPendingMark />
                                    Day{challenge.Day}
                                </div>
                            ) : (
                                <div className={s.calendarNotAvailable} key={challenge.Day}>
                                    <SvgNotAvailableMark />
                                    Day{challenge.Day}
                                </div>
                            )
                        ) : (
                            <div className={s.calendarSuccess} key={challenge.Day}>
                                <SvgCheckMark />
                                Day{challenge.Day}
                            </div>
                        )
                    )}
            </div>

            {/* Loading */}
            {isLoading && (
                <div
                    role="status"
                    className="w-full h-full absolute flex items-center justify-center top-0 left-0 bg-[#ffffffb3]"
                >
                    <svg
                        aria-hidden="true"
                        className="w-12 h-12 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                        />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                        />
                    </svg>
                    <span className="sr-only">Loading...</span>
                </div>
            )}
        </div>
    );
}

export default Dashboard;
